import React from "react";
import { Warehouse } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { MobileNav } from "./MobileNav";

export function Header() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <header className="sticky top-0 z-30 flex h-16 items-center border-b border-slate-200 bg-white px-4 sm:px-6">
      <MobileNav role={user.role} />
      <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-slate-500">
        <Warehouse className="h-3.5 w-3.5" />
        <span className="hidden sm:inline">Dallas, TX · Operations Hub</span>
        <span className="sm:hidden">Dallas, TX</span>
      </div>
    </header>
  );
}
